module.exports = __webpack_public_path__ + "static/media/8OLA29.0690863c.jpg";